import { getCompanyImage, getUniversityImage } from "../../common/styles/Images";
import { getFieldOfStudyName } from "../../features/alumni/alumni-profile/service/student-profile-view.service";
import { getDomainValueForCode, getFlexColDomainValueForCode } from "../Core/SmartFunctions";

const WORKING_STATUS_DATA_MAP: Record<string, string> = {
    TEACHING_AND_RESEARCH: 'teachingWork',
    PROFESSIONAL_PRACTICE: 'professionalPractice',
    IN_DEFENCE: 'defenceWork',
    SELF_EMPLOYED_AND_FREELANCING: 'freelancing',
    ENTREPRENEURSHIP: 'entreprenurship',
    WORKING_FOR_A_COMPANY: 'jobs'
};

const WORKING_STATUS_CODES = Object.keys(WORKING_STATUS_DATA_MAP);

export const getWorkingStatusInfo = (state: any, workingPrefix: string = 'Working As') => {
    const profile = state?.data?.profile;
    if (!profile) return null;

    const workingStatusCode = profile?.workingStatusCode;
    if (!workingStatusCode || !WORKING_STATUS_CODES.includes(workingStatusCode)) return null;

    const dataKey = WORKING_STATUS_DATA_MAP[workingStatusCode];
    const rawData = state?.data?.[dataKey];
    const currentData = Array.isArray(rawData) ? rawData[0] : rawData;

    if (!currentData) return null;

    let entityHeading = '';
    let entityLogo = '';
    let flexData = null;

    if (workingStatusCode === 'TEACHING_AND_RESEARCH') {
        const flexDataJson = getFlexColDomainValueForCode(currentData?.instituteId, 'INSTITUTE_DOMAIN', state);
        flexData = flexDataJson ? JSON.parse(flexDataJson) : null;
        entityHeading = currentData?.instituteId
            ? getDomainValueForCode(currentData?.instituteId, 'INSTITUTE_DOMAIN', state)
            : currentData?.otherInstitute;
        entityLogo = getUniversityImage(flexData?.logo);
    } else {
        const flexDataJson = getFlexColDomainValueForCode(currentData?.companyId, 'COMPANY_CODE', state);
        flexData = flexDataJson ? JSON.parse(flexDataJson) : null;
        entityHeading = currentData?.companyId
            ? getDomainValueForCode(currentData?.companyId, 'COMPANY_CODE', state)
            : currentData?.otherCompany;
        entityLogo = getCompanyImage(flexData?.logo);
    }

    let designation = '';
    if (workingStatusCode === 'ENTREPRENEURSHIP') designation = 'Founder';
    else if (workingStatusCode === 'SELF_EMPLOYED_AND_FREELANCING') designation = currentData?.designationCredited || '';
    else if (workingStatusCode==='IN_DEFENCE') designation =currentData?.designationRank
    else designation = currentData?.designation || '';

    const formattedDesignation = designation
        ?.toLowerCase()
        ?.replace(/_/g, ' ')
        ?.replace(/\b\w/g, (char: string) => char.toUpperCase());

    return {
        currentStatus: workingPrefix,
        entityHeading,
        entityLogo,
        entitySubHeading: formattedDesignation,
        startDate: currentData?.startDate || '',
        endDate: currentData?.isCurrent === 1 
                ? '(Present)' 
                : currentData?.endDate 
                    ? `- ${currentData.endDate}` 
                    : '-'    };
};


// --- Main service for CurrentInformation ---
export const getCurrentInformationData = (state: any) => {
    const profile = state?.data?.profile;

    console.log("profile",profile)
    if (!profile) return null;

    const workingStatusCode = profile?.workingStatusCode;
    const presentStatus = profile?.presentEducationStatusCode;
    const pursuingLevel = profile?.pursuingEducationLevelCode;
    const highestCompleted = profile?.highestCompletedEducationLevelCode;

    //  Working ---
    if (workingStatusCode && WORKING_STATUS_CODES.includes(workingStatusCode)) {
         const workingData = getWorkingStatusInfo(state,'Working At - ');
             console.log("workingData",workingData)

        if (!workingData) return null;

        return {
            startYear: new Date(workingData.startDate).getFullYear() ,
            name: `(${workingData.entitySubHeading})`,
            label: `${workingData.currentStatus} ${workingData.entityHeading}`,
            entityLogo: workingData.entityLogo,
            endDate : workingData?.endDate
        };
    }

    // Not Working / Pursuing / Completed Education ---
    let name = '';
    let label = ''; 
    let level = '';
    if (presentStatus === 'COMPLETED_STUDIES') {
        level = highestCompleted;
    } else if (presentStatus === 'PURSUING_STUDIES') {
        level = pursuingLevel;
    }
    console.log("level",level)
 
    switch (level) {
        case 'UG': {
            const ug = state?.data?.underGradCollegeJoined;
            if (ug) {
                const university =
                getDomainValueForCode(ug?.universityId, 'INSTITUTE_DOMAIN', state)
                ?? ug?.otherUniversity
                ?? '';

                const field = ug?.fieldOfStudyCode
                ? ` (${getFieldOfStudyName(ug.fieldOfStudyCode, state)})`
                : '';

                name = `${university}${field}`;
                label = presentStatus === 'COMPLETED_STUDIES' ? 'Completed UG - ' : 'Pursuing UG - ';
            }
            break;
        }
        case 'PG':
        case 'Doctoral': {
            const education = state?.data?.postGradCollegeJoined?.[0];

            if (education) {

                const university =
                    getDomainValueForCode(
                        education?.universityId,
                        'INSTITUTE_DOMAIN',
                        state
                    ) ?? education?.otherUniversity ?? '';

                const field = education?.fieldOfStudyCode
                    ? ` (${getFieldOfStudyName(education.fieldOfStudyCode, state)})`
                    : '';

                name = `${university}${field}`;

                const levelLabel = level === 'Doctoral' ? 'Doctoral' : 'PG';

                label = presentStatus === 'COMPLETED_STUDIES'
                    ? `Completed ${levelLabel} - `
                    : `Pursuing ${levelLabel} - `;
            }

            break;
        }

        default:
            return null;
    }

    if (!name) return null;

    return { label, name };
};